import { render, staticRenderFns } from "./Lag.vue?vue&type=template&id=8569a96e&scoped=true&"
import script from "./Lag.vue?vue&type=script&lang=js&"
export * from "./Lag.vue?vue&type=script&lang=js&"
import style0 from "./Lag.vue?vue&type=style&index=0&id=8569a96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8569a96e",
  null
  
)

export default component.exports